export const navigator = {
    step: "banner",
    steps: [
        {
            step: "banner",
            title: "Registration",
            label: "Registration",
            next: "vehicle",
            previous: null,
            showNavigation: false,
        },
        {
            step: "vehicle",
            title: "Vehicle Registration",
            label: "Vehicle look up",
            next: "confirm",
            previous: "banner",
            showNavigation: true,
            pills: {
                item: 1,
                total: 2,
            },
        },
        {
            step: "confirm",
            title: "Is this your car?",
            label: "Is this your car?",
            next: "complete",
            previous: "vehicle",
            showNavigation: true,
            pills: {
                item: 2,
                total: 2,
            },
        },
        {
            step: "complete",
            title: "Thank you",
            label: "Thank you",
            next: null,
            previous: "confirm",
            showNavigation: false,
        },
    ],
};
